import { defineCustomElement } from 'vue';
import Multiple from '../../../src/vue/shared/filtro/filtros/relatorios/Multiple.vue';
import plugins from '../../../src/vue/shared/filtro/plugins';
try {
  if (!customElements.get('filtro-relatorio')) {
    const FiltroRelatorioElement = defineCustomElement(Multiple, {
      shadowRoot: false,
      configureApp(app) {
        app.use(plugins);
      }
    });
    customElements.define('filtro-relatorio', FiltroRelatorioElement);
  }
} catch (error) {
  console.error('Falha ao definir o componente customizado:', error);
}